import DateFnsUtils from '@date-io/date-fns'
import { Box, Grid, makeStyles, Card, Typography } from '@material-ui/core'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import CustomInput from '../../components/CustomInput'
import CustomSelect from '../../components/CustomSelect'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useLeadType } from '../../hooks/CompanyConfiguration/useLeadType'
import { useCustomer } from '../../hooks/Features/useCustomer'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { useLead } from '../../hooks/Features/useLeads'
import { formatDate, formatNumber, ROUTES } from '../../shared/constants'
import { useHistory, useLocation } from 'react-router-dom'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import AddIcon from '@material-ui/icons/Add'
import { ProductContext } from '../../context api/Product/ProductContext'
import { useProduct } from '../../hooks/Features/useProduct'
import CustomCounter from '../../components/CustomCounter'
import CustomImage from '../../components/CustomImage'
import EditIcon from '../../assets/images/icons/edit.svg'
import classes from './Lead.module.css'
import MailIcon from '@material-ui/icons/Mail'
import CustomButton from '../../components/CustomButton'

export default function CustomerGrid({
  leadTypeName,
  profilePicture,
  customerState,
  customerCity,
  customerName,
  editUrl,
}) {
  const history = useHistory()
  const { sendQuote } = useLead()

  return (
    <>
      {/* <Grid item className={classes.customerGrid}>
        <Grid container>
          <Grid item className={`${classes.customerDetailsGrid1} ${classes.contentCenterGrid}`}>
            <div style={{ backgroundColor: '#FF8181', color: 'white' }} className={classes.quoteStatus}>
              {leadTypeName}
            </div>
          </Grid>
          <Grid item className={`${classes.customerDetailsGrid2} ${classes.contentCenterGrid}`}>
            <div>
              <img src={profilePicture} height="90px" width="90px" style={{ borderRadius: '100%' }} />
              <br />
              {customerName}
              <br />
              <LocationOnIcon /> {customerState}, {customerCity}
            </div>
          </Grid>
          <Grid item className={`${classes.customerDetailsGrid3}`}>
            <div style={{ textAlign: 'right', margin: '10px 10px 0 0' }}>
              <CustomImage image={EditIcon} className={classes.icons} onClick={() => history.push(editUrl)} />
            </div>
            
          </Grid>
        </Grid>
      </Grid> */}

      <Card style={{ width: '100%', padding: '20px 50px 75px 50px' }}>
        <Box display="flex" justifyContent="space-between">
          <div style={{ backgroundColor: '#FF8181', color: 'white' }} className={classes.quoteStatus}>
            {leadTypeName}
          </div>
          <CustomImage image={EditIcon} className={classes.icons} onClick={() => history.push(editUrl)} />
        </Box>
        {/* <div style={{ textAlign: 'right', margin: '10px 10px 0 0' }}>
         
        </div>
       */}
        <div style={{ display: 'grid', justifyContent: 'center', flexDirection: 'column' }}>
          <img src={profilePicture} height="90px" width="90px" style={{ borderRadius: '100%' }} />
          <Typography style={{ textAlign: 'center' }}>{customerName}</Typography>
          <Box display="flex">
            <LocationOnIcon /> {customerState}, {customerCity}
          </Box>
        </div>
      </Card>
    </>
  )
}
